require('./iron/common/stylesheets/defaults/color-vars.styl');
require('./media/js/auth');
